import { useNavigate } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { BUSINESS } from "@/data/servicesData";

export const CTABand = ({ heading = "READY TO GET IT SORTED?", sub }) => {
  const navigate = useNavigate();
  const goQuote = () => { navigate("/"); setTimeout(() => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" }), 350); };
  return (
    <section className="bg-[#2563EB] border-y-2 border-[#0A1A4A]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
        <div>
          <h2 className="font-display font-black text-white text-3xl sm:text-5xl tracking-tight leading-[0.95]">{heading}</h2>
          <p className="text-white/80 mt-3 max-w-xl">{sub || `Tell us the job and we'll get you a price by email. £${BUSINESS.minCharge} minimum per job — no surprises.`}</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 shrink-0">
          <button onClick={goQuote} data-testid="cta-quote" className="bg-white text-[#0A1A4A] font-display font-extrabold uppercase tracking-wide px-7 py-4 border-2 border-[#0A1A4A] shadow-hard hover:bg-[#EAB308] transition-colors flex items-center gap-2">
            Get A Quote <ArrowRight size={18} />
          </button>
          <a href={`tel:${BUSINESS.phoneRaw}`} data-testid="cta-call" className="bg-[#0A1A4A] text-white font-display font-extrabold uppercase tracking-wide px-7 py-4 border-2 border-[#0A1A4A] hover:bg-[#0A1A4A]/80 transition-colors flex items-center gap-2">
            <Phone size={18} /> {BUSINESS.phone}
          </a>
        </div>
      </div>
    </section>
  );
};
